<template>
  <div class="dev-panel">
    <div class="popup-title">展示用控制面板</div>
    <p class="muted intro">
      這個 demo 沒有真正的登入系統，用這個面板切換「目前用哪位成員的身分檢視」，
      就能看到可見性（3.3）與角色權限（3.2.1）如何影響畫面；也可以模擬離線記錄（5.10）。
    </p>

    <div class="block">
      <div class="section-title">檢視身分</div>
      <div class="member-grid">
        <button
          v-for="m in members" :key="m.id" type="button"
          class="member-btn" :class="{ active: viewingAsMemberId === m.id }"
          @click="setViewingAs(m.id)"
        >
          <MemberAvatar :member="m" :size="26" />
          <span>{{ m.name }}</span>
          <span class="role">{{ m.role === 'owner' ? 'Owner' : 'Member' }}</span>
        </button>
      </div>
    </div>

    <div class="block">
      <div class="section-title">
        離線模擬
        <van-switch :value="simulateOffline" size="20" @input="toggleOffline" />
      </div>
      <p class="muted">開啟後，快速記錄／記帳會先進入「待同步」清單，模擬離線時仍可操作，恢復連線後再「立即上傳」。</p>
      <div v-if="syncQueue.length" class="sync-queue">
        <div v-for="item in syncQueue" :key="item.id" class="sync-item">
          <span>🕒 {{ item.summary }}</span>
        </div>
        <van-button size="small" type="primary" block @click="flush">立即上傳（{{ syncQueue.length }} 則待同步）</van-button>
      </div>
      <p v-else class="muted">目前沒有待同步的項目。</p>
    </div>

    <div class="block">
      <van-button block plain type="danger" @click="reset">重設示範資料</van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Dialog } from 'vant'
import MemberAvatar from '@/components/common/MemberAvatar.vue'

export default {
  name: 'DevPanel',
  components: { MemberAvatar },
  props: {
    tripId: { type: String, required: true }
  },
  computed: {
    ...mapGetters({ membersByTrip: 'members/byTrip' }),
    members () {
      return this.membersByTrip(this.tripId)
    },
    viewingAsMemberId () {
      return this.$store.state.ui.viewingAsMemberId
    },
    simulateOffline () {
      return this.$store.state.ui.simulateOffline
    },
    syncQueue () {
      return this.$store.state.ui.syncQueue
    }
  },
  methods: {
    ...mapActions({
      setViewingAsAction: 'ui/setViewingAs',
      toggleOfflineAction: 'ui/toggleOffline',
      flushSyncQueue: 'ui/flushSyncQueue'
    }),
    setViewingAs (id) {
      this.setViewingAsAction(id)
    },
    toggleOffline () {
      this.toggleOfflineAction()
    },
    flush () {
      this.flushSyncQueue()
    },
    reset () {
      Dialog.confirm({ title: '重設示範資料', message: '會清除所有 demo 操作紀錄' }).then(() => {
        this.$store.dispatch('resetDemoData')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.dev-panel { padding-bottom: 20px; max-height: 80vh; overflow-y: auto; }
.popup-title { padding: 16px; font-weight: 700; font-size: 16px; border-bottom: 1px solid var(--color-border); }
.intro { padding: 12px 16px 0; line-height: 1.6; }
.block { padding: 14px 16px; }
.member-grid { display: flex; gap: 8px; flex-wrap: wrap; }
.member-btn {
  display: flex; flex-direction: column; align-items: center; gap: 4px;
  padding: 10px; border-radius: var(--radius-md); border: 1px solid var(--color-border); background: #fff; font-size: 11px;
}
.member-btn.active { border-color: var(--color-primary); background: #fff5f0; }
.role { font-size: 10px; color: var(--color-text-dim); }
.section-title { display: flex; align-items: center; justify-content: space-between; }
.sync-queue { margin-top: 8px; display: flex; flex-direction: column; gap: 6px; }
.sync-item { font-size: 12px; background: #fff8ef; padding: 6px 10px; border-radius: 8px; }
</style>
